import Stars from './stars';

export default Stars;



// WEBPACK FOOTER //
// ./src/pages/profile/blocks/cards/review/components/index.ts